const data = {
  products: [
      {
          "_id": "62c60b33fc2abfd53ecb1b3f",
          "name": "Car",
          "slug": "car",
          "image": "/images/car.jpg",
          "images": [],
          "category": "vecicles",
          "description": "Classic lego piece little car. Very easy to build for every age. Dimentions: xxcm/ xxcm/ xxcm",
          "price": 25,
          "countInStock": 15,
          "rating": 3,
          "numReviews": 1,
          "reviews": [
              {
                  "name": "Danny(admin)",
                  "comment": "classic lego piece",
                  "rating": 3,
                  "_id": "62cb26e9d008eebec3f7f415",
                  "createdAt": "2022-07-10T19:22:17.292Z",
                  "updatedAt": "2022-07-10T19:22:17.292Z"
              }
          ],
          "__v": 1,
          "createdAt": "2022-07-06T22:22:43.802Z",
          "updatedAt": "2022-07-19T17:58:17.122Z",
          "isFeatured": false
      },
      {
          "_id": "62c60b33fc2abfd53ecb1b40",
          "name": "Truck",
          "slug": "truck",
          "image": "/images/truck.jpg",
          "images": [],
          "category": "vecicles",
          "description": "An amazing lego truck that transforms into a cart and a sport car. Dimentions: xxcm/ xxcm/ xxcm",
          "price": 95,
          "countInStock": 15,
          "rating": 3.5,
          "numReviews": 25,
          "reviews": [],
          "__v": 0,
          "createdAt": "2022-07-06T22:22:43.803Z",
          "updatedAt": "2022-07-19T17:53:47.276Z",
          "isFeatured": false
      },
      {
          "_id": "62c60b33fc2abfd53ecb1b41",
          "name": "Boat",
          "slug": "boat",
          "image": "/images/boat.jpg",
          "images": [],
          "category": "vecicles",
          "description": "Resque boat lego transform into a desert 4x4 model. Dimentions: xxcm /xxcm / xxcm",
          "price": 78,
          "countInStock": 15,
          "rating": 3.5,
          "numReviews": 25,
          "reviews": [],
          "__v": 0,
          "createdAt": "2022-07-06T22:22:43.803Z",
          "updatedAt": "2022-07-19T17:51:26.619Z",
          "isFeatured": false
      },
      {
          "_id": "62c60b33fc2abfd53ecb1b43",
          "name": "Fast car",
          "slug": "fast-car",
          "image": "/images/fast-car.jpg",
          "images": [],
          "category": "vecicles",
          "description": "A very sweet model of a sport car low on pieces. dimentions : xxcm / xxcm /xxcm",
          "price": 78,
          "countInStock": 15,
          "rating": 3.5,
          "numReviews": 25,
          "reviews": [],
          "__v": 0,
          "createdAt": "2022-07-06T22:22:43.803Z",
          "updatedAt": "2022-07-19T17:50:25.850Z",
          "isFeatured": true
      },
      {
          "_id": "62c60b33fc2abfd53ecb1b44",
          "name": "Offroad Power",
          "slug": "offroad-power",
          "image": "/images/offroad-power.jpg",
          "images": [],
          "category": "vecicles",
          "description": "An off-road 4x4 jeep that towing an all-terrain vehicle . Dimantions: xxcm/ xxcm/ xxcm",
          "price": 78,
          "countInStock": 15,
          "rating": 3.5,
          "numReviews": 25,
          "reviews": [],
          "__v": 0,
          "createdAt": "2022-07-06T22:22:43.803Z",
          "updatedAt": "2022-07-19T17:57:19.823Z",
          "isFeatured": true
      },
      {
          "_id": "62c60b33fc2abfd53ecb1b45",
          "name": "Lego truck",
          "slug": "truck2",
          "image": "/images/truck2.jpg",
          "images": [],
          "category": "vecicles",
          "description": "A lego truck from the lego town collection with a driver minifigure . Dimentions: xxcm/ xxcm/ xxcm",
          "price": 78,
          "countInStock": 15,
          "rating": 1,
          "numReviews": 1,
          "reviews": [
              {
                  "name": "Danny(admin)",
                  "comment": "gtp",
                  "rating": 1,
                  "_id": "62cb325ed008eebec3f7f49c",
                  "createdAt": "2022-07-10T20:11:10.587Z",
                  "updatedAt": "2022-07-10T20:11:10.587Z"
              }
          ],
          "__v": 1,
          "createdAt": "2022-07-06T22:22:43.804Z",
          "updatedAt": "2022-07-19T17:59:35.226Z",
          "isFeatured": false
      },
      {
          "_id": "62d46aaccfd77397cc5291d7",
          "name": "Create Your Own Minifigure",
          "slug": "create-your-own-minifigure",
          "image": "/images/create-your-own-minifigure.jpg",
          "images": [],
          "category": "minifigure",
          "description": "Create and order your own creations. Choose the head, body and legs you as you like ",
          "price": 10,
          "countInStock": 10,
          "rating": 5,
          "numReviews": 1,
          "isFeatured": true,
          "reviews": [
              {
                  "name": "Danny(admin)",
                  "comment": "Amazing Product",
                  "rating": 5,
                  "_id": "62d479efcfd77397cc529221",
                  "createdAt": "2022-07-17T21:06:55.366Z",
                  "updatedAt": "2022-07-17T21:06:55.366Z"
              }
          ],
          "createdAt": "2022-07-17T20:01:48.186Z",
          "updatedAt": "2022-07-18T14:29:55.107Z",
          "__v": 1
      }
  ]
};

export default data;
